import React, { Component } from "react"

import { images } from "../../config/image-definitions"

export default class ResetSuccessForm extends Component {
    onSubmit = event => {
        event.preventDefault()
        this.props.toggleForm("loginForm")()
    }

    render() {
        return (
            <form
                id="resetSuccess"
                name="resetSuccess"
                onSubmit={this.onSubmit}
            >
                <div className="form-header">
                    <img
                        src={images.emailSent}
                        alt="Email sent"
                        className="img--email-sent"
                    />
                </div>
                <p className="text-align--center">
                    We have sent you an email with instructions to reset your
                    password.
                </p>
                <button
                    type="submit"
                    className="btn btn-info btn-login margin-top--15"
                    name="submit"
                >
                    Return to login
                </button>
            </form>
        )
    }
}
